import Layout from "../components/Layout";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { SitemapBreadcrumb, defBreadcrumb } from "../data/DataBreadcrumb";
import { SitemapMeta } from "../data/DataMetatags";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import SitemapComponent from "../components/SitemapComponent";
type SitemapProps = {
  breadcrumb?: any;
  title?: string;
  description?: string;
  path?: string;
  SitemapBreadcrumb?: string;
};

const Sitemap = ({
  breadcrumb,
  title,
  description,
  path,
  SitemapBreadcrumb
}: SitemapProps) => {
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={SitemapBreadcrumb} />
      <HeadingComponent
        headingText="Sitemap"
        fontSize="32px"
        fontWeight="bold"
      />
      <SitemapComponent />
    </Layout>
  );
};
export const getStaticProps = async () => {
  const { title, description, path } = SitemapMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: { breadcrumb, SitemapBreadcrumb, title, description, path }
  };
};
export default Sitemap;
